module.exports = __webpack_public_path__ + "media/images/photo/top/plan/plan2-94038b90c0bd99a1f6743e595600cf15.jpg";